
    import {Inject, Options, Prop, Vue} from 'vue-property-decorator';
    import {Getter} from 'vuex-class';
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {CreationFormValidation} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
    import getters from '@/profile-creation-wizard/components/for-creation/store/getters';
    import type {ProfileCreationForm} from '@/profile-creation-wizard/components/for-creation/store';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import mutations from '@/profile-creation-wizard/components/for-creation/store/mutations';

    @Options({})
    export default class HeadlineSelection extends Vue {
        @Inject({from: DI.creationFormValidation})
        creationFormValidation!: CreationFormValidation;
        @Getter(getters.creationForm)
        creationForm!: ProfileCreationForm;
        @Prop({type: String, required: true})
        title!: string;
        @Prop({type: String, required: false})
        subtitle?: string;
        @Prop({type: String, required: false})
        subtitleHelp?: string;

        $refs!: {
            headline: HTMLInputElement;
        };
        bottomSheetSelector = '#headline-details-bottom-sheet';
        dataHeapTooltipID = 'profile-creation-tooltip-headline';

        error = false;

        mounted(): void {
            this.bottomSheetDisplayer = new BottomSheetDisplayer(
                this.bottomSheetSelector,
                this.dataHeapTooltipID,
                this.$el,
                'div.profile-creation-wizard',
            );
            this.bottomSheetDisplayer.mounted();
        }

        openBottomSheet(): void {
            this.bottomSheetDisplayer.openBottomSheet();
        }

        emitFocus(): void {
            // TODO no magic bus
            eventBusProfileCreationWizard.emit('creation:focus-changed', TipsPart.title);
        }

        validate(): void {
            if (this.$refs.headline.value.trim().length === 0) {
                this.error = true;
                return;
            }

            this.error = !this.creationFormValidation.isHeadlineValid(this.creationForm.headline);
        }

        get hasError(): boolean {
            return this.error;
        }

        headlineKeypressEnter(event: any): void {
            this.updateHeadline(event.target.value);

            if (!this.error) {
                this.$emit('headline-keypress-enter');
            }
        }

        headlineValueChange(event: any): void {
            this.updateHeadline(event.detail.value);
        }

        updateHeadline(headline: string): void {
            this.creationForm.headline = headline;
            this.validate();
            this.$store.commit(mutations.clearFamiliesAndCategories);
        }
    }
